import React, { useState, useEffect } from 'react';
import { Box, Typography,Chip,TableBody,Table,TableContainer,TableHead,TableRow,Paper,CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';
import Newuser from './Modalnewuser';
import Delete from './Popdeleteuser';
import Edituser from './Popedituser';
import PopUnlockUser from './PopUnlockUser';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import BASE_URL from '../../config';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: grey[100],
        color: theme.palette.common.black,
    }
}));

export default function Usuarios() { 
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${BASE_URL}/users/allusers`);
            const data = await response.json();
            setRows(data);
        } catch (error) {
            console.error("Error cargando usuarios:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <Box sx={{p:0,m:0}}>
            <Box sx={{display:'flex',flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent:'space-between',gap: 2}}>
                <Box sx={{mr:2}}>
                    <Typography variant='h6'>Administración de Usuarios</Typography>
                    <Typography variant='body1' color='textSecondary'>
                        Gestiona los usuarios del sistema
                    </Typography>
                </Box>
                <Box sx={{width:{xs:'100%', sm:'auto'} }}>
                    <Newuser refresh={fetchUsers}/>
                </Box>
            </Box>

            <TableContainer component={Paper} sx={{mt:3, maxHeight: 590,borderRadius: 3,
                border:`1px solid ${grey[400]}`,
                overflowX: 'auto' ,
                // Ocultar para Firefox
                scrollbarWidth: 'auto',
                // Ocultar para Internet Explorer y Edge antiguo
                msOverflowStyle: 'auto',}}>
                <Table stickyHeader aria-label="customized table">
                    <TableHead sx={{bgcolor:grey[100]}}>
                    <TableRow>
                        <StyledTableCell sx={{ fontWeight: 'bold',width:'auto'}} align="left">Nombre</StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: 'bold' }} align="left">Contacto</StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: 'bold' }} align="left">Rol</StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: 'bold' }} align="left">Estado</StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: 'bold' }} align="left">Seguridad</StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: 'bold' }} align="right">Acciones</StyledTableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {loading ? (
                        <TableRow>
                            <TableCell colSpan={6} sx={{ py: 10 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <CircularProgress size={40} sx={{ color: grey[500] }} />
                                    <Typography sx={{ mt: 2, color: grey[600] }}>Cargando usuarios...</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ) : rows.map((row) => (
                        <TableRow
                        hover 
                        key={row.id} 
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell>
                            <Box sx={{ display: 'flex',alignItems: 'center', 
                                whiteSpace: 'nowrap',flexWrap: 'nowrap'}}>
                                <PersonOutlineIcon sx={{ mr: 1, fontSize: '20px' }} />
                                {row.nombre_completo ? (row.nombre_completo) : (
                                <Typography component="span" variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                                    Indefinido
                                </Typography>)}
                            </Box>
                        </TableCell> 

                        <TableCell align="left">
                            <Box sx={{ display: 'flex', flexDirection:'column',lineHeight: 1,gap:0.5}}>
                                    <Box sx={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        lineHeight: 1}}>
                                        <MailOutlineIcon sx={{mx:1}}/>{row.email}
                                    </Box>
                                    <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            lineHeight: 1, 
                                            }}>
                                        <PhoneEnabledOutlinedIcon sx={{mx:1 }}/>
                                +52 {row.phone}
                                    </Box>
                            </Box>
                        </TableCell>
                        
                        <TableCell align="left">
                            <Chip size="small" variant="outlined" sx={{bgcolor:'white',fontWeight:'bold'}} label={row.nombre_rol||'sin rol'}>
                            </Chip>
                        </TableCell>
                        <TableCell align="left">
                        {row.estado ? (
                            <Chip size="small" variant="filled" sx={{bgcolor:"black"}} color='primary' label='Activo'/>
                        ) : (
                            <Chip size="small" variant="filled" color='error' label='Inactivo'/>
                        )}
                        </TableCell>
                        <TableCell align="left">
                            <PopUnlockUser user={row} refresh={fetchUsers}/>
                        </TableCell>
                        <TableCell align="right">
                            <Box sx={{display:'flex',flexDirection:'row', justifyContent:'flex-end', gap:0.5}}>
                                {/* Pasamos los datos y la función refresh (refrescar) a los modales */}
                                <Edituser user={row} refresh={fetchUsers}/>
                                <Delete user={row} refresh={fetchUsers}/>
                            </Box>
                        </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </Box>
    )
}